import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { CustomCartEntryEffects } from './store/effects/custom-cart-entry.effect';

@NgModule({
  declarations: [],
  imports: [CommonModule, EffectsModule.forFeature(CustomCartEntryEffects)],
})
export class CartFormsStoreModule {}
